import { useTranslations } from '@/hooks/use-translations';
import { AssetViewer } from '@/modules/asset-viewer';
import { Asset } from '@/modules/case/types';

interface SupportingDocumentsPanelProps {
  isOpen: boolean;
  onClose: () => void;
  assets: Asset[];
  assetsBaseUrl: string;
}

export const SupportingDocumentsPanel = ({
  isOpen,
  onClose,
  assets,
  assetsBaseUrl,
}: SupportingDocumentsPanelProps) => {
  const { t } = useTranslations();

  return (
    <AssetViewer
      isOpen={isOpen}
      onClose={onClose}
      assets={assets}
      assetsBaseUrl={assetsBaseUrl}
      initialIndex={0}
      title={t('caseViewer.navigation.supportingDocs')}
    />
  );
};
